import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder, getTicketTypeById, getEventInfosByEventId, getCountries, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";
import { motion } from "framer-motion";

import Header from "./components/Header";
import Loading from "./components/Loading";

// maps a ticket type's additionalField.saveToField id to the Ticket property it is stored on
const ticketQueryFields = [
    { id: 0, description: "Salutation" },
    { id: 1, description: "FirstName" },
    { id: 2, description: "LastName" },
    { id: 3, description: "Company" },
    { id: 4, description: "BirthDate" },
    { id: 5, description: "Street" },
    { id: 6, description: "City" },
    { id: 7, description: "PostCode" },
    { id: 8, description: "Phone" },
    { id: 9, description: "Email" },
    { id: 10, description: "Option1" },
    { id: 11, description: "Option2" },
    { id: 12, description: "Option3" },
    { id: 13, description: "Option4" },
    { id: 14, description: "Option5" },
    { id: 15, description: "Option6" },
    { id: 16, description: "Option7" },
    { id: 17, description: "Option8" },
    { id: 18, description: "Option9" },
    { id: 19, description: "Option10" },
    { id: 20, description: "Option11" },
    { id: 21, description: "Option12" },
    { id: 22, description: "Option13" },
    { id: 23, description: "Option14" },
    { id: 24, description: "Option15" },
    { id: 25, description: "Option16" },
    { id: 26, description: "Option17" },
    { id: 27, description: "Option18" },
    { id: 28, description: "Option19" },
    { id: 29, description: "Option20" },
    { id: 30, description: "Function" },
    { id: 31, description: "Position" },
    { id: 32, description: "Country" },
    { id: 33, description: "Option21" },
    { id: 34, description: "Option22" },
    { id: 35, description: "Option23" },
    { id: 36, description: "Option24" }
];

const Shipping = () => {
    const [order, setOrder] = useState({});
    const [orderId] = useState(localStorage.getItem("orderId"));
    const [tickets, setTickets] = useState([]);
    const [ticketsAddress, setTicketsAddress] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);
    const [isError, setIsError] = useState(false);
    const [isTicketFieldsError, setIsTicketFieldsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buyerInfo, setBuyerInfo] = useState(() => {
        // Try to load from localStorage on first render
        const orderId = localStorage.getItem("orderId");
        const sessionBuyerInfo = orderId && localStorage.getItem(`buyerInfo_${orderId}`);
        if (sessionBuyerInfo) {
            return JSON.parse(sessionBuyerInfo);
        }
        return {
            firstName: "",
            name: "",
            countryId: 176,
            email: "",
            /*newsletter: false*/
        };
    });

    const eventId = localStorage.getItem("EventId");

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [countries, setCountries] = useState([]);

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            break;
    }

    const [tokenReady, setTokenReady] = useState(false);

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await localStorage.setItem("token", res.data);
                setTokenReady(true); // Set tokenReady after token is set

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (orderId > 0) {
                    loadOrder(orderId)
                } else {
                    localStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate(`/${language}/home/${eventId}`);
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    // Only call requestResources and loadCountries when tokenReady is true and language changes
    useEffect(() => {
        if (tokenReady) {
            requestResources();
            loadCountries();
        }
    }, [language, tokenReady]);

    //redirect to home when there are no tickets in the order
    useEffect(() => {
        if (order.tickets && order.tickets.length === 0) {
            navigate(`/${language}/home/${eventId}`);
        }
    }, [tickets]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const removePromotionCode = async (promotion) => {
        try {
            const response = axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotion}`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const loadCountries = async () => {
        try {
            let countries = await getCountries(language);

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            var indexFR = countries.findIndex(c => c.id === 59);
            const fr = countries[indexFR];
            countries.splice(indexFR, 1);

            var indexIT = countries.findIndex(c => c.id === 87);
            const it = countries[indexIT];
            countries.splice(indexIT, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(it);
            countries.unshift(au);
            countries.unshift(fr);
            countries.unshift(de);
            countries.unshift(ch);

            setCountries(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate(`/${language}/home/${eventId}`);
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);
            const bookedTickets = updatedOrder.tickets;
            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);
                    const ticketTypeInfoResp = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = ticketTypeInfoResp.find(info => info.languageId == languageId) ?? ticketTypeInfoResp[0];

                    const eventInfoResp = await getEventInfosByEventId(ticketType.eventId);
                    const eventInfo = eventInfoResp.eventInfos.find(info => info.languageId == languageId) ?? eventInfoResp.eventInfos[0];

                    return { ...ticket, ticketType: ticketType, ticketTypeInfo, eventInfo };
                })
            )

            // per-ticket address/additionalFields values, keyed by ticketId
            const updatedTicketsAddress = bookedTickets.map((ticket) => {
                const address = { ticketId: ticket.id, ...ticket };

                ticketQueryFields.forEach((field) => {
                    const key = field.description.charAt(0).toLowerCase() + field.description.slice(1);
                    address[key] = address[key] ?? "";
                });

                return address;
            });

            setTickets(updatedTickets);
            setTicketsAddress(updatedTicketsAddress);
            setOrder(updatedOrder);

            // Prefill buyer info if address exists
            const address = await getAddressOfOrder(orderId);
            // Check for localStorage first
            const sessionBuyerInfo = localStorage.getItem(`buyerInfo_${orderId}`);
            if (sessionBuyerInfo) {
                setBuyerInfo(JSON.parse(sessionBuyerInfo));
            } else {
                setBuyerInfo({
                    ...buyerInfo,
                    ...address
                    /*newsletter: address.code1 === "true" //convert to bool*/
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const onInputChange = (e) => {
        setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
    };

    const onInputChangeTicket = (e, ticketId) => {
        setTicketsAddress((prevTicketsAddress) =>
            prevTicketsAddress.map((ta) =>
                ta.ticketId === ticketId ? { ...ta, [e.target.name]: e.target.value } : ta
            )
        );
    };

    const validateTicketField = (address, property) => {
        const element = document.getElementById(property + address.ticketId);
        const isValid = address[property] && address[property].toString().trim().length > 0;

        if (element) element.style.border = isValid ? "1px solid #dee2e6" : "1px solid red";

        return isValid;
    };

    const validateTicketAdditionalFields = () => {
        let isValid = true;

        ticketsAddress.forEach((address) => {
            const selectedTicket = tickets.find((t) => t.id === address.ticketId);
            const additionalFields = selectedTicket?.ticketType?.additionalFields ?? [];

            additionalFields.forEach((field) => {
                if (field?.isMandatory) {
                    const saveToFieldString = ticketQueryFields.find((f) => f.id === field.saveToField)?.description ?? "Option1";
                    const saveToField = saveToFieldString.charAt(0).toLowerCase() + saveToFieldString.slice(1);

                    if (!validateTicketField(address, saveToField)) {
                        isValid = false;
                    }
                }
            });
        });

        setIsTicketFieldsError(!isValid);

        return isValid;
    };

    const updateTicketsAddress = async () => {
        try {
            await Promise.all(
                ticketsAddress.map(async (address) => {
                    const selectedTicket = tickets.find((t) => t.id === address.ticketId);

                    if (!(selectedTicket?.ticketType?.additionalFields?.length > 0)) return;

                    // remove this when we remove 'lastname' and 'firstname' from ticket apimodel
                    const updateTicketBody = {
                        ...address,
                        firstname: address.firstName,
                        lastname: address.lastName,
                    };

                    try {
                        await axios.put(`${baseUrl}/Ticket/${address.ticketId}/Address`, updateTicketBody);
                    } catch (error) {
                        console.error(`Error updating ticket ${address.ticketId}:`, error);
                    }
                })
            );
        } catch (error) {
            console.error(error);
        }
    };

    const mapAdditionalFields = (field, address) => {
        const fieldControl = field.fieldControl;
        const fieldTitle = field?.title?.[languageId] ?? field?.title?.[1];

        const fieldOptions = field?.options?.map((option) => {
            option.text = option?.optionValues?.[languageId] ?? option?.optionValues?.[1];
            return option;
        }) ?? [];

        const saveToFieldString = ticketQueryFields.find((f) => f.id == field.saveToField)?.description ?? "Option1";
        const saveToField = saveToFieldString.charAt(0).toLowerCase() + saveToFieldString.slice(1);
        const isMandatory = field?.isMandatory ? "*" : "";
        const elementId = saveToField + address.ticketId;

        // RadioButtonList
        if (fieldControl == 0) {
            return (
                <div className="mb-3" key={elementId}>
                    <p className="mb-2">{fieldTitle}{isMandatory}</p>
                    {fieldOptions?.length > 0 && fieldOptions.map((option, i) => (
                        <React.Fragment key={i}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={saveToField + address.ticketId}
                                    id={elementId}
                                    checked={address[saveToField]?.split(";")[0] == option?.text}
                                    onChange={() => {
                                        setTicketsAddress((prevTicketsAddress) =>
                                            prevTicketsAddress.map((ta) => {
                                                if (ta.ticketId !== address.ticketId) return ta;

                                                let values = ta[saveToField]?.split(";") ?? [];
                                                values[0] = option?.text;

                                                if (!option?.hasOptionText) {
                                                    values.splice(1, 1);
                                                }

                                                return { ...ta, [saveToField]: values.join(";") };
                                            })
                                        );
                                    }}
                                />
                                <label className="form-check-label" htmlFor={elementId}>
                                    {option?.text}
                                </label>
                            </div>
                            {(option?.hasOptionText && address[saveToField]?.split(";")[0] == option?.text) &&
                                <input
                                    className="form-control mt-2"
                                    type="text"
                                    name={saveToField}
                                    id={elementId}
                                    value={address[saveToField]?.split(";")[1] ?? ""}
                                    onChange={(e) => {
                                        const newTextValue = e.target.value;
                                        setTicketsAddress((prevTicketsAddress) =>
                                            prevTicketsAddress.map((ta) => {
                                                if (ta.ticketId !== address.ticketId) return ta;

                                                let values = ta[saveToField]?.split(";") ?? [];
                                                values[1] = newTextValue;
                                                return { ...ta, [saveToField]: values.join(";") };
                                            })
                                        );
                                    }} />
                            }
                        </React.Fragment>
                    ))}
                </div>
            );
        }

        // CheckboxList
        if (fieldControl == 1) {
            return (
                <div className="mb-3" key={elementId}>
                    <p className="mb-2">{fieldTitle}{isMandatory}</p>
                    {fieldOptions?.length > 0 && fieldOptions.map((option, i) => (
                        <React.Fragment key={i}>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name={saveToField}
                                    id={elementId + "_" + i}
                                    checked={address[saveToField]?.split(";")?.includes(option?.text) ?? false}
                                    onChange={(e) => {
                                        setTicketsAddress((prevTicketsAddress) =>
                                            prevTicketsAddress.map((ta) => {
                                                if (ta.ticketId !== address.ticketId) return ta;

                                                let values = ta[saveToField]?.split(";") ?? [];

                                                if (e.target.checked) {
                                                    values.push(option?.text);
                                                } else {
                                                    if (option?.hasOptionText) {
                                                        const textIndex = values.indexOf(option.text) + 1;
                                                        if (textIndex < values.length) {
                                                            values[textIndex] = "";
                                                        }
                                                    }
                                                    values = values.filter((v) => v != option?.text);
                                                }

                                                return { ...ta, [saveToField]: values.filter((v) => v?.length > 0).join(";") };
                                            })
                                        );
                                    }}
                                />
                                <label className="form-check-label" htmlFor={elementId + "_" + i}>
                                    {option?.text} {isMandatory}
                                </label>
                            </div>
                            {((option?.hasOptionText) && address[saveToField]?.split(";")?.includes(option?.text)) &&
                                <input
                                    className="form-control mt-2"
                                    type="text"
                                    name={saveToField}
                                    id={elementId + "_" + i + "_text"}
                                    value={address[saveToField]?.split(";")[address[saveToField]?.split(";").indexOf(option.text) + 1] ?? ""}
                                    onChange={(e) => {
                                        const newTextValue = e.target.value;
                                        setTicketsAddress((prevTicketsAddress) =>
                                            prevTicketsAddress.map((ta) => {
                                                if (ta.ticketId !== address.ticketId) return ta;

                                                let values = ta[saveToField]?.split(";") ?? [];
                                                const index = values.indexOf(option.text);
                                                if (index !== -1) {
                                                    values[index + 1] = newTextValue;
                                                }
                                                return { ...ta, [saveToField]: values.join(";") };
                                            })
                                        );
                                    }} />
                            }
                        </React.Fragment>
                    ))}
                </div>
            );
        }

        // Dropdown
        if (fieldControl == 2) {
            return (
                <div className="mb-3" key={elementId}>
                    <p className="mb-2">{fieldTitle}{isMandatory}</p>
                    <select
                        className="form-select"
                        name={saveToField}
                        id={elementId}
                        value={address[saveToField] ?? ""}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                    >
                        <option value="">{resources?.PleaseSelect}</option>
                        {fieldOptions?.length > 0 && fieldOptions.map((option, i) => (
                            <option value={option?.text} key={i}>{option?.text}</option>
                        ))}
                    </select>
                </div>
            );
        }

        // Textbox
        if (fieldControl == 3) {
            return (
                <div className="mb-3" key={elementId}>
                    <label htmlFor={elementId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        className="form-control"
                        type="text"
                        name={saveToField}
                        id={elementId}
                        value={address[saveToField] ?? ""}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)} />
                </div>
            );
        }

        // MultilineTextbox
        if (fieldControl == 4) {
            return (
                <div className="mb-3" key={elementId}>
                    <label htmlFor={elementId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <textarea
                        className="form-control"
                        rows="3"
                        name={saveToField}
                        id={elementId}
                        value={address[saveToField] ?? ""}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                    ></textarea>
                </div>
            );
        }

        // EmailTextbox
        if (fieldControl == 5) {
            return (
                <div className="mb-3" key={elementId}>
                    <label htmlFor={elementId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        type="email"
                        className="form-control"
                        name={saveToField}
                        id={elementId}
                        value={address[saveToField] ?? ""}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)}
                        placeholder="name@example.com" />
                </div>
            );
        }

        // TelephoneNumberTextbox
        if (fieldControl == 6) {
            return (
                <div className="mb-3" key={elementId}>
                    <label htmlFor={elementId} className="form-label">{fieldTitle}{isMandatory}</label>
                    <input
                        className="form-control"
                        type="text"
                        name={saveToField}
                        id={elementId}
                        value={address[saveToField] ?? ""}
                        onChange={(e) => onInputChangeTicket(e, address.ticketId)} />
                </div>
            );
        }

        // Text label
        if (fieldControl == 7) {
            return (
                <div className="mb-3" key={elementId}>
                    <p className="mb-2">{fieldTitle}</p>
                </div>
            );
        }

        return null;
    };

    // Refactored addAddressToBasket to accept a callback for navigation
    const addAddressToBasket = async (onSuccess) => {

        let addressBody = {
            firstName: buyerInfo.firstName,
            name: buyerInfo.name,
            countryId: buyerInfo.countryId,
            email: buyerInfo.email,
            /*code1: buyerInfo.newsletter,*/
        };

        try {
            await axios.put(`${baseUrl}/Order/${orderId}/Address`, addressBody);

            // Store the latest buyerInfo in localStorage.
            // This ensures that if the user returns to this page, the displayed data is up-to-date,
            // even if the API response is delayed and may not reflect the most recent changes yet.
            localStorage.setItem(`buyerInfo_${orderId}`,
                JSON.stringify({ ...buyerInfo })
            );

            //// gtm - addAddress
            //window.dataLayer = window.dataLayer || [];
            //window.dataLayer.push({
            //    'event': 'addAddress'
            //});

            if (onSuccess) onSuccess();
        } catch (error) {
            console.error(error.response?.data || error);
            navigate(`/${language}/home/${eventId}`);
        }
    };

    const onSubmit = async () => {
        const isBuyerValid = validateInputFields();
        const isTicketFieldsValid = validateTicketAdditionalFields();

        if (!isBuyerValid || !isTicketFieldsValid) return;

        setLoading(true);

        await updateTicketsAddress();

        await addAddressToBasket(() => {
            navigate(`/${language}/checkout`);
        });
    }

    //// Handler for BuyerBookMoreTickets button
    //const onBookMoreTickets = async () => {
    //    setLoading(true);
    //    await addAddressToBasket(() => {
    //        window.location.href = resources?.BuyerBookMoreTicketsUrl;
    //    });
    //}

    const validateInputFields = () => {
        let validation =
            buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName) &&
            buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name) &&
            buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email);

        setIsError(!validation);
        return validation;

    }

    const removeTicketFromBasket = (id) => {
        let deleteBody = {
            ticketsToRemove: [id],
        };

        axios
            .delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                headers: {
                    Accept: "application/json",
                },
                data: deleteBody,
            })
            .then(() => loadOrder(orderId));
    }

    const onBackClick = async () => {
        navigate(-1)
    }

    const redirectToExternalTickets = () => {
        window.location.href = resources?.BuyerBookMoreTicketsUrl;
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt) => {
                const address = ticketsAddress.find((ta) => ta.ticketId === tt.id) ?? {};
                const additionalFields = tt.ticketType?.additionalFields ?? [];

                return (
                    <div key={tt.id} className="tickets-box p-4 pt-3 mb-3">
                        <div className="row align-items-start mb-2">
                            <div className="col-8 text-start">
                                <label className="ticket-name-label mb-0 fw-semibold">
                                    {tt.eventInfo?.name}
                                </label>
                                <label className="ticket-name-label mb-0 d-block">
                                    1x {tt.ticketTypeInfo?.name}
                                </label>
                            </div>
                            <div className="col-4 d-flex align-items-start justify-content-end">
                                <label className="mb-0">
                                    {tt.ticketTypePrice > 0 ? `${tt.ticketType?.currency} ${tt.ticketTypePrice.toFixed(2)}` : resources?.Free}
                                </label>
                                <button
                                    className="btn btn-link p-0 m-0 text-decoration-none ms-2"
                                    onClick={() => removeTicketFromBasket(tt.id)}
                                    aria-label="Remove ticket"
                                    style={{ outline: 'none', boxShadow: 'none' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="19"
                                        fill="none"
                                        stroke="#4F5054"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        viewBox="0 0 24 24"
                                        style={{ marginTop: '-2px' }}
                                    >
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        {additionalFields.length > 0 &&
                            <div className="row mt-3">
                                <div className="col-md-12 text-start">
                                    {additionalFields.map((field) => mapAdditionalFields(field, address))}
                                </div>
                            </div>
                        }
                    </div>
                );
            })
        );
    };

    return (
        <>
            {loading ? (
                <>
                    <Loading
                        alignment="center"
                        color="#d3d3d3"
                        bgColor="transparent"
                        top="50%"
                        resources={resources}
                    />
                </>
            ) : (
                <>
                    <Header
                        language={language}
                        pagePath="address"
                        isShoppingCartVisible={true}
                        numberOfTickets={order?.tickets?.length ?? 0}
                    />

                    <motion.div
                        className="page-container"
                        initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                        animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
                    >
                        <div className="container wrapper">

                            <div className="mt-5">
                                {mapTickets()}
                            </div>

                            {isTicketFieldsError &&
                                <div className="row text-start mt-2">
                                    <p className="text-error">{resources?.ErrorPleaseFillMandatoryFields}</p>
                                </div>
                            }

                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <span className="text-title">{resources?.BuyerPleaseFill}</span>
                                </div>
                            </div>

                            <div className="tickets-box p-4 mt-3">
                                {/* Buyer */}

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="firstName"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerFirstname}
                                            value={buyerInfo.firstName}
                                            id="firstName"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerLastname}
                                            value={buyerInfo.name}
                                            id="name"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerEmail}
                                            value={buyerInfo.email}
                                            id="email"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                {isError &&
                                    <div className="row text-start mt-2">
                                        <p className="text-error">{resources?.ErrorPleaseFillMandatoryFields}</p>
                                    </div>
                                }

                                {buyerInfo?.email !== buyerInfo?.confirmemail && buyerInfo?.confirmemail?.length > 0 &&
                                    <div className="row">
                                        <div className="col-12 text-end">
                                            <span className="error">{resources?.BuyerErrorPasswordMismatch}</span>
                                        </div>
                                    </div>
                                }

                                <div className="row mt-5">
                                    {/*<div className="col-6">*/}
                                    {/*    <button className="btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>*/}
                                    {/*</div>*/}
                                    <div className="col-12 text-end">
                                        <button className="btn-custom" onClick={() => onSubmit()}>{resources?.Next}</button>
                                    </div>
                                </div>
                            </div>

                            {/* Book More Tickets Section */}
                            {/*<div className="row mt-4 mb-4">*/}
                            {/*    <div className="col-12 text-center">*/}
                            {/*        <button*/}
                            {/*            className="btn-custom-secondary"*/}
                            {/*            onClick={onBookMoreTickets}*/}
                            {/*            style={{*/}
                            {/*                backgroundColor: "#293E6E",*/}
                            {/*                color: "white",*/}
                            {/*                padding: "10px 20px",*/}
                            {/*                borderRadius: "4px",*/}
                            {/*                border: "none",*/}
                            {/*                fontWeight: "600",*/}
                            {/*                textTransform: "uppercase"*/}
                            {/*            }}*/}
                            {/*        >*/}
                            {/*            {resources?.BuyerBookMoreTickets}*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    <p className="mt-4">
                                        <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </>
    )
}

export default Shipping